import { useContext } from 'react';
import { PaperPlaneRight } from '@phosphor-icons/react';
import ThreadInputBoxContext, {
  ThreadInputBoxContextType,
} from 'src/contexts/ThreadInputBoxContext';
import { useSubmitUserInput } from 'src/hooks';
import { GUEST_ACCESS_TASK_INPUT_VALUE, SVG_SIZE_M } from 'src/constants';
import AuthContext from 'src/contexts/AuthContext';
import { AppRoutes } from 'src/types';

interface SendMessageButtonProps {
  isDisabled: boolean;
}

export const SendMessageButton = ({ isDisabled }: SendMessageButtonProps) => {
  const { threadInputBoxValue } = useContext<ThreadInputBoxContextType>(
    ThreadInputBoxContext,
  );
  const { isGuestAccess } = useContext(AuthContext);

  const { onSubmitShowMigration } = useSubmitUserInput();

  const handleSubmit = () => {
    if (isGuestAccess) {
      localStorage.setItem(GUEST_ACCESS_TASK_INPUT_VALUE, threadInputBoxValue);

      window.location.href = AppRoutes.LOGIN;
      return;
    }

    onSubmitShowMigration();
  };

  return (
    <button
      data-e2e="main-submit-button"
      aria-label="Send a message"
      disabled={isDisabled}
      className="nj-chat-form--submit-button"
      onClick={handleSubmit}
    >
      <PaperPlaneRight
        size={SVG_SIZE_M}
        color="currentColor"
        weight={isDisabled ? 'regular' : 'fill'}
      />
    </button>
  );
};
